import { render, staticRenderFns } from "./ResourceLabel.vue?vue&type=template&id=22c801e6&scoped=true"
import script from "./ResourceLabel.vue?vue&type=script&lang=js"
export * from "./ResourceLabel.vue?vue&type=script&lang=js"
import style0 from "./ResourceLabel.vue?vue&type=style&index=0&id=22c801e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c801e6",
  null
  
)

export default component.exports